export default __webpack_public_path__ + "static/media/survey5.3237f623.svg";